import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Enterprise, EntityType } from '../entity.types';
import { UserContext } from '../../user/UserContext';
import { EntityInfos } from '../expertises/infos/EntityInfos';
import { EnterpriseList } from '../entity-lists/EnterpriseList';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import styles from './entity_defended_enterprises.module.scss';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../components/EntityBlockComponents';
import { SeeMore } from '../../components/see-more/SeeMore';

type Props = {
  enterprises: Array<Enterprise>;
  entityName: string;
  entityType: EntityType;
  entityId: string;
  decisionCount: number;
  source: string;
  pluralityState: number;
  wording: string;
  handleSeeMoreEnterprisesClick:
    | ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void)
    | null;
  handleClickDecision: Function;
};

export const EntityDefendedEnterprises: FC<Props> = ({
  entityName,
  pluralityState,
  handleSeeMoreEnterprisesClick,
  enterprises,
  source,
  entityType,
  entityId,
  decisionCount,
  handleClickDecision,
  wording,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();

  if (!pluralityState) return null;

  return (
    <EntityBlock>
      <EntityBlockTitle>
        <FormattedMessage
          id="defended-enterprises/DefendedEnterprises.tsx/1"
          values={{ count: pluralityState }}
        />
      </EntityBlockTitle>
      <EntityInfos
        decisionCount={decisionCount}
        entityType={entityType}
        lawyerId={entityId}
        entityName={entityName}
      />
      {accessPremium ? (
        <>
          <EnterpriseList
            enterprises={enterprises}
            source={source}
            wording={wording}
            handleClickDecision={handleClickDecision}
          />
          {handleSeeMoreEnterprisesClick !== null && (
            <SeeMore onClick={handleSeeMoreEnterprisesClick}>
              <FormattedMessage id="defended-enterprises/DefendedEnterprises.tsx/3" />
            </SeeMore>
          )}
        </>
      ) : (
        <div className={styles.button}>
          <button
            className="button brand"
            onClick={() =>
              openRestrictedModal({ source: `${source}_see_more` })
            }
            type="button"
          >
            <FormattedMessage id="defended-enterprises/DefendedEnterprises.tsx/4" />
          </button>
        </div>
      )}
    </EntityBlock>
  );
};
